import { render, staticRenderFns } from "./TsSelect.vue?vue&type=template&id=16474bcd&"
import script from "./TsSelect.vue?vue&type=script&lang=js&"
export * from "./TsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports